package de.oevbs.kunde.kundenportal2.model.services.consent

import de.oevbs.businesspartner.consent2.model.CustomerModel
import de.oevbs.kunde.kundenportal2.ServiceInfo
import de.oevbs.sfa.communication.ClientDefinition
import de.oevbs.sfa.communication.ClientResponse

abstract class ConsentClientDefinition(origin: String) : ClientDefinition(ServiceInfo, origin, ServiceInfo.name) {

    override val requestTimeoutMillis: Long = 30000L

    /**
     * Prüft, ob die Einwilligungen des eingeloggten Users/Partners aktualisiert werden müssen.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun check(): ClientResponse<Boolean> =
        get("/consent/check")

    /**
     * Läd die Einwilligungen des eingeloggten Users/Partners zur Kontaktaufnahme durch die Öffentliche.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun init(): ClientResponse<CustomerModel> =
        get("/consent/init")

    /**
     * Speichert die Einwilligungen des eingeloggten Users/Partners zur Kontaktaufnahme durch die Öffentliche..
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun save(consent: CustomerModel): ClientResponse<Unit> =
        post("/consent/save", consent)

}